import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  getDetailParams,
  hasModalityPermission,
  USER_TYPE,
  redirectToApp
} from '@plataforma/utils';
import { JUDICIAIS, resumeQuote, forceDownload } from '_/utils';
import { useRemoteConfig } from '_/context/RemoteConfigContext';
import { getUserProfile } from '@services/auth';
import { PoliciesAPI } from '@services/api';
import Card from '../../components/Card';

function CardList({ items, resumeAction }) {
  const history = useHistory();
  const { t } = useTranslation();
  const [remoteState] = useRemoteConfig();

  const verifyPermissions = async item => {
    const { idExternoModalidade, idExternoSubmodalidade } = item;
    let authorizedModality = false;
    let hasPermission = false;

    authorizedModality = await hasModalityPermission(
      idExternoModalidade,
      idExternoSubmodalidade
    );

    hasPermission =
      !!(getUserProfile() === USER_TYPE.broker || USER_TYPE.commercial) ||
      authorizedModality;

    return hasPermission;
  };

  const getProcessNumberLabel = processItem => {
    return Object.values(JUDICIAIS).includes(processItem.modalityId)
      ? 'judicial'
      : 'edital';
  };

  const handleRequestEmission = async documentNumber => {
    redirectToApp('endosso', 'retake', {
      document: documentNumber
    });
  };

  const callAction = async processItem => {
    const authorizedModality = await verifyPermissions(processItem);

    if (!remoteState.isSusepValidated && remoteState.config.susepCheck) {
      resumeAction('invalidRegister');
      return;
    }

    if (!authorizedModality) {
      resumeAction('unauthorized');
      return;
    }

    if (processItem.mainPolicyNumber) {
      handleRequestEmission(processItem.documentNumber);
    } else {
      resumeQuote(processItem, remoteState.config.v3Settings);
    }
  };

  async function onClickDownloadPolicy(documentNumber) {
    const {
      data: { linkDocumento = '', linkMinuta = '' }
    } = await PoliciesAPI.GetPolicyInformation(documentNumber);

    const link = linkDocumento || linkMinuta;
    return forceDownload(link);
  }

  function showRetakeButton(description, modalityId) {
    if (description === 'Fiança Locatícia' || modalityId === 123) {
      return false;
    }
    return true;
  }

  return (
    <>
      {items &&
        items.map(item => (
          <Card
            key={item.id}
            menuItems={item.menu}
            policyStatusId={item.quoteStatus.groupName}
            policyStatusLabel={item.quoteStatus.title}
            policyHolder={item.name}
            labelButton={item.actionLabel}
            labelStatusNumber={item.processLabel}
            processNumber={item.judicialProcessNumber}
            processNumberLabel={getProcessNumberLabel(item)}
            controlId={item.customerControlIdentifies}
            processId={item.processId}
            modality={item.description}
            showRetakeButton={showRetakeButton(
              item.description,
              item.modalityId
            )}
            endorsementTypeId={item.endorsementTypeId}
            endorsement={
              (item.isEndorsment && item.endorsementStatusMessage) ||
              (item.hasEndorsement && t('card.defaultEndorsementMsg'))
            }
            onClickActionButton={() => callAction(item)}
            onClickCard={() =>
              history.push(
                getDetailParams({
                  quoteStatus: item.quoteStatus.id,
                  documentNumber:
                    item.mainPolicyNumber !== null
                      ? item.mainPolicyNumber
                      : item.documentNumber,
                  processId: item.id
                })
              )
            }
            onClickDownloadPolicy={() =>
              onClickDownloadPolicy(item.documentNumber)
            }
          />
        ))}
    </>
  );
}

CardList.propTypes = {
  items: PropTypes.instanceOf(Array).isRequired,
  resumeAction: PropTypes.func,
  user: PropTypes.shape({
    modalities: PropTypes.arrayOf(PropTypes.string),
    profile: PropTypes.string
  })
};

export default CardList;
